

import { call, put, takeLatest, all } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_CHASSEURS_REQUEST,
    fetchChasseursSuccess,
    fetchChasseursFail,

    CREATE_CHASSEUR_REQUEST,
    createChasseurSuccess,
    createChasseurFail,

    UPDATE_CHASSEUR_REQUEST,
    updateChasseurSuccess,
    updateChasseurFail,

    DELETE_CHASSEUR_REQUEST,
    deleteChasseurSuccess,
    deleteChasseurFail,

    // Domaines
    FETCH_DOMAINES_REQUEST,
    fetchDomainesSuccess,
    fetchDomainesFail,

    setChasseursLoading,
} from "../actions/chasseursActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

// ===== FormData (payload + image) =====
export function buildChasseurFormData(payload) {
    const fd = new FormData();

    // on standardise: payload.imageFile
    const imageFile = payload?.imageFile || null;

    const clean = { ...payload };
    delete clean.imageFile;

    // backend attend: siteweb, domaineIds
    fd.append("payload", JSON.stringify(clean));

    if (imageFile) fd.append("image", imageFile);

    return fd;
}

// ===== Fetch chasseurs =====
export function* fetchChasseursSaga() {
    const url = `${API_BASE_URL}/api/chasseurs`;
    const uid = getUid();
    const token = getToken();

    yield put(setChasseursLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchChasseursSuccess(resp.data));
    } catch (e) {
        yield put(fetchChasseursFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setChasseursLoading(false));
    }
}

// ===== Create =====
export function* createChasseurSaga(action) {
    const url = `${API_BASE_URL}/api/chasseurs`;
    const uid = getUid();
    const token = getToken();

    yield put(setChasseursLoading(true));
    try {
        const fd = buildChasseurFormData(action.payload);

        const resp = yield call(postRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(createChasseurSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Chasseur de tête ajouté",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CHASSEURS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout chasseur";
        yield put(createChasseurFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setChasseursLoading(false));
    }
}

// ===== Update =====
export function* updateChasseurSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/chasseurs/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setChasseursLoading(true));
    try {
        const fd = buildChasseurFormData(payload);

        const resp = yield call(putRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(updateChasseurSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Chasseur de tête modifié",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CHASSEURS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification chasseur";
        yield put(updateChasseurFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setChasseursLoading(false));
    }
}

// ===== Delete =====
export function* deleteChasseurSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/chasseurs/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setChasseursLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteChasseurSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Chasseur de tête supprimé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression chasseur";
        yield put(deleteChasseurFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setChasseursLoading(false));
    }
}

// ===== Fetch domaines (mini) =====
// IMPORTANT: nécessite un endpoint backend: GET /api/domaines (comme Catalogue->Formations)
// Si ton endpoint diffère, change ici.
export function* fetchDomainesSaga() {
    const url = `${API_BASE_URL}/api/domaines`;
    const uid = getUid();
    const token = getToken();

    yield put(setChasseursLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchDomainesSuccess(resp.data));
    } catch (e) {
        yield put(fetchDomainesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setChasseursLoading(false));
    }
}


